import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/authStore'

export default function LoginPage() {
  const [email, setEmail]       = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError]       = useState('')
  const navigate = useNavigate()
  const login = useAuthStore((state) => state.login)

  // A forced-logout redirect (client.ts, on a failed token refresh) is a
  // hard page navigation, not a router transition — it can't hand this
  // page a message directly, so it leaves one in sessionStorage instead.
  useEffect(() => {
    try {
      const notice = sessionStorage.getItem('authNotice')
      if (notice) {
        setError(notice)
        sessionStorage.removeItem('authNotice')
      }
    } catch { /* private browsing, storage disabled */ }
  }, [])

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setIsLoading(true)
    setError('')
    try {
      await login(email, password)
      navigate('/dashboard')
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed')
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#0A1930' }}>
      <div className="w-full max-w-md">
        {/* Logo mark */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-32 h-32 flex items-center justify-center mb-4">
            <img src="/water-icon.svg" alt="I-SOFT Waterworks" className="w-32 h-32" />
          </div>
          <h1 className="text-2xl font-bold text-brand-ice tracking-tight">I-SOFT Waterworks</h1>
          <p className="text-brand-gray text-sm mt-1">Portal za komunalne sisteme</p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          {error && (
            <div className="mb-4 p-4 bg-red-50 border border-red-200 rounded-lg">
              <p className="text-red-800 text-sm">{error}</p>
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Email</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand-cyan focus:border-transparent outline-hidden text-sm"
                placeholder="korisnik@vodograd.rs"
              />
            </div>

            <div>
              <label className="block text-sm font-semibold text-gray-700 mb-1">Lozinka</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="current-password"
                className="w-full px-4 py-2.5 border border-gray-300 rounded-xl focus:ring-2 focus:ring-brand-cyan focus:border-transparent outline-hidden text-sm"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={isLoading}
              className="w-full text-brand-midnight font-semibold py-2.5 rounded-xl transition-opacity disabled:opacity-60 mt-2 bg-brand-cyan hover:bg-brand-cyan-dark"
            >
              {isLoading ? 'Prijavljivanje…' : 'Prijavite se'}
            </button>
          </form>

          <div className="mt-6 p-4 rounded-xl" style={{ backgroundColor: '#F0F7FF', border: '1px solid #E1F7FE' }}>
            <p className="text-xs font-bold uppercase tracking-widest mb-1" style={{ color: '#8892B0' }}>Demo nalog</p>
            <p className="text-sm" style={{ color: '#0A1930' }}>demo@vodograd.rs</p>
            <p className="text-sm font-mono" style={{ color: '#207492' }}>Vodograd2026!</p>
          </div>
        </div>
      </div>
    </div>
  )
}
